import styled from 'styled-components';

export const ViewControls = styled.div`
  display: inline-flex;
  margin: 0 5px;

  button {
    font-size: 12px;
    line-height: 37px;
    height: 37px;
    min-width: 88px;
    border-radius: 0;
    justify-content: center;

    &:first-child {
      border-top-left-radius: 18px;
      border-bottom-left-radius: 18px;
    }

    &:last-child {
      border-top-right-radius: 18px;
      border-bottom-right-radius: 18px;
    }
  }
`;
